import type { IMessageType } from '@/services/signalr/types';
import type { IShiftUpdateReqMsg } from '~/api/messages/IShiftUpdateReqMsg';
import type { IShiftUpdateRespMsg } from '~/api/messages/IShiftUpdateRespMsg';
import type { IShiftsReqMsg } from '~/api/messages/IShiftsReqMsg';
import type { IShiftsRespMsg } from '~/api/messages/IShiftsRespMsg';

export const ShiftUpdateReqMsg: IMessageType<IShiftUpdateReqMsg, IShiftUpdateRespMsg> = {
  requestName: 'ShiftUpdateReqMsg',
  responseName: 'ShiftUpdateRespMsg',
};

export const ShiftsReqMsg: IMessageType<IShiftsReqMsg, IShiftsRespMsg> = {
  requestName: 'ShiftsReqMsg',
  responseName: 'ShiftsRespMsg',
};
